<script>
  let {
    title = '',
    subtitle = '',
    variant = 'full',
    showTear = true,
    children,
  } = $props();
</script>

<div class="receipt-card receipt-card--{variant}" class:receipt={variant === 'full'}>
  {#if showTear && variant === 'full'}
    <div class="receipt-tear-top"></div>
  {/if}

  {#if title || subtitle}
    <div class="receipt-card__header">
      {#if title}
        <h2 class="receipt-card__title">{title}</h2>
      {/if}
      {#if subtitle}
        <p class="receipt-card__subtitle">{subtitle}</p>
      {/if}
    </div>
  {/if}

  <div class="receipt-card__body">
    {#if children}
      {@render children()}
    {/if}
  </div>

  {#if showTear && variant === 'full'}
    <div class="receipt-tear-bottom"></div>
  {/if}
</div>

<style>
  /* Full variant uses global .receipt class; compact/mini get own styles */
  .receipt-card {
    position: relative;
    font-family: var(--font-mono);
  }

  .receipt-card--compact {
    background: var(--receipt-bg);
    border: 1px solid var(--receipt-border);
    border-radius: var(--receipt-radius);
    padding: 16px;
    max-width: var(--receipt-width);
    margin: 0 auto;
    box-shadow: var(--receipt-shadow);
  }

  .receipt-card--mini {
    background: var(--receipt-bg);
    border: 1px solid var(--receipt-border);
    border-radius: 4px;
    padding: 12px 16px;
    max-width: 320px;
    margin: 0 auto;
    box-shadow: var(--receipt-shadow);
  }

  /* Paper texture overlay */
  .receipt-card::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    pointer-events: none;
    opacity: 0.03;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E");
    background-size: 128px 128px;
    mix-blend-mode: overlay;
  }

  .receipt-card__header {
    text-align: center;
    margin-bottom: var(--receipt-section-gap, 16px);
  }

  .receipt-card__title {
    font-family: var(--font-mono);
    font-size: var(--receipt-size-title, 1.5rem);
    font-weight: 700;
    letter-spacing: 4px;
    text-transform: uppercase;
    color: var(--receipt-text-primary);
    margin: 0;
  }

  .receipt-card--mini .receipt-card__title {
    font-size: var(--receipt-size-label, 0.85rem);
    letter-spacing: 2px;
  }

  .receipt-card__subtitle {
    font-family: var(--font-mono);
    font-size: var(--receipt-size-meta, 0.75rem);
    color: var(--receipt-text-secondary);
    letter-spacing: 1px;
    margin: 4px 0 0;
  }

  .receipt-card__body {
    position: relative;
    z-index: 1;
  }
</style>
